import { Field } from 'redux-form';
import MultiInputField from './MultiInput';

const MultiInput = (props) => {
  return <Field name={props.name} component={MultiInputField} {...props} />;
}

export default MultiInput;